(function (window) {
  'use strict';

  const neverActiveTabClass = 'js-accordion-tabs-feature-tab';
  const neverActiveTabListItemClass = 'js-accordion-tabs-feature-tab-list-item';

  function initInstance(instance) {
    const tabs = instance.querySelectorAll('.js-accordion-tabs-tab');
    const accordionControls = instance.querySelectorAll('.js-accordion-tabs-accordion-control');
    const featureTabContent = instance.querySelector('.js-accordion-tabs-content-wrapper:first-child');

    for (let i = 0; i < tabs.length; i++) {
      if (featureTabContent && i === 0) {
        tabs[i].classList.add(neverActiveTabListItemClass);
        tabs[i].classList.add(neverActiveTabClass);
      }
      else {
        tabs[i].addEventListener('click', handleTab);
      }
    }

    for (let i = 0; i < accordionControls.length; i++) {
      accordionControls[i].addEventListener('click', handleAccordionControl);
    }
  }

  function handleTab(e) {
    const tab = e.target.closest('.js-accordion-tabs-tab');
    const instance = tab.closest('.js-accordion-tabs');
    const tabs = instance.querySelectorAll('.js-accordion-tabs-tab');
    const contentWrappers = instance.querySelectorAll('.js-accordion-tabs-content:not(:first-child)');

    for (let i = 0; i < tabs.length; i++) {
      if (!tabs[i].classList.contains(neverActiveTabClass)) {
        if (tabs[i] == tab) {
          tabs[i].setAttribute('aria-expanded', true);
        }
        else {
          tabs[i].setAttribute('aria-expanded', false);
        }
      }
    }

    for (let i = 0; i < contentWrappers.length; i++) {
      if (contentWrappers[i].getAttribute('data-tab') == tab.getAttribute('data-tab')) {
        contentWrappers[i].setAttribute('aria-hidden', false);
      }
      else {
        contentWrappers[i].setAttribute('aria-hidden', true);
      }
    }
  }

  function handleAccordionControl(e) {
    const control = e.target;
    const selectedTab = control.getAttribute('data-tab');
    const instance = control.closest('.js-accordion-tabs');
    // The `data-accordion-tabs-collapse-all="true"` attribute allows expanded
    // content to be collapsed, so that all panels are collapsed.
    const collapseAll = instance.getAttribute('data-accordion-tabs-collapse-all') === 'true';
    const tabs = instance.querySelectorAll('.js-accordion-tabs-tab');
    const tabMobile = instance.querySelectorAll('.js-accordion-tabs-accordion-control');
    const contentWrappers = instance.querySelectorAll('.js-accordion-tabs-content');

    // @todo Refactor each of the for loops below to extract logic from
    // imperative code and call open/close functions instead.
    for (let i = 0; i < tabMobile.length; i++) {
      if (tabMobile[i].getAttribute('data-tab') == selectedTab) {
        if (collapseAll && tabMobile[i].getAttribute('aria-expanded') === 'true') {
          tabMobile[i].setAttribute('aria-expanded', false);
        } else {
          tabMobile[i].setAttribute('aria-expanded', true);
        }
      }
      else {
        tabMobile[i].setAttribute('aria-expanded', false);
      }
    }

    for (let i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('data-tab') == selectedTab) {
        if (collapseAll && tabs[i].getAttribute('aria-expanded') === 'true') {
          tabs[i].setAttribute('aria-expanded', false);
        } else {
          tabs[i].setAttribute('aria-expanded', true);
        }
      }
      else {
        tabs[i].setAttribute('aria-expanded', false);
      }
    }

    for (let i = 0; i < contentWrappers.length; i++) {
      if (contentWrappers[i].getAttribute('data-tab') == selectedTab) {
        if (collapseAll && contentWrappers[i].getAttribute('aria-hidden') === 'false') {
          contentWrappers[i].setAttribute('aria-hidden', true);
        } else {
          contentWrappers[i].setAttribute('aria-hidden', false);
        }
      }
      else {
        contentWrappers[i].setAttribute('aria-hidden', true);
      }
    }
  }

  function init() {
    const instances = document.querySelectorAll('.js-accordion-tabs');

    for (let i = 0; i < instances.length; i++) {
      if (!instances[i].classList.contains('js-component-init')) {
        initInstance(instances[i]);

        instances[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
